"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ControlMessage_1 = __importDefault(require("../ControlMessage"));
const ProxyConnectionRequest_1 = __importDefault(require("./ProxyConnectionRequest"));
const Serializer_1 = require("../../../Serializer");
const StreamID_1 = require("../../../../src/utils/StreamID");
const VERSION = 2;
/* eslint-disable class-methods-use-this */
class ProxyConnectionRequestSerializerV2 extends Serializer_1.Serializer {
    toArray(proxyConnectionRequest) {
        return [
            VERSION,
            ControlMessage_1.default.TYPES.ProxyConnectionRequest,
            proxyConnectionRequest.requestId,
            proxyConnectionRequest.streamId,
            proxyConnectionRequest.streamPartition,
            proxyConnectionRequest.senderId,
            proxyConnectionRequest.direction,
            proxyConnectionRequest.userId
        ];
    }
    fromArray(arr) {
        const [version, __type, requestId, streamId, streamPartition, senderId, direction, userId] = arr;
        return new ProxyConnectionRequest_1.default({
            version,
            requestId,
            streamId: (0, StreamID_1.toStreamID)(streamId),
            streamPartition,
            senderId,
            direction,
            userId
        });
    }
}
exports.default = ProxyConnectionRequestSerializerV2;
ControlMessage_1.default.registerSerializer(VERSION, ControlMessage_1.default.TYPES.ProxyConnectionRequest, new ProxyConnectionRequestSerializerV2());
//# sourceMappingURL=ProxyConnectionRequestSerializerV2.js.map